import React from 'react';
import { Flex, Box } from 'theme-ui';
import ContentText from '@solid-ui-components/ContentText';
import WithDefaultContent from '@solid-ui-blocks/WithDefaultContent';
import Icon from '@solid-ui-components/ContentIcon/ContentIcon';
import styles from './styles';

const { wrapper, container, section, sections, sectionIcon, sectionText } =
  styles;

const MainTask = ({ content: { text, collection } }) => (
  <Flex sx={wrapper}>
    <Flex sx={container}>
      <Box>
        <ContentText content={text} />
      </Box>
      <Flex sx={sections}>
        {collection.map((col, index) => (
          <Flex key={`main-task-${index}`} sx={section}>
            <Flex sx={sectionIcon}>
              <Icon content={col.icon} size='xxs' />
            </Flex>
            <Flex sx={sectionText}>
              <ContentText content={col.text} />
            </Flex>
          </Flex>
        ))}
      </Flex>
    </Flex>
  </Flex>
);

export default WithDefaultContent(MainTask);
